<template>
  <v-menu
    offset-y
    left
    transition="slide-y-transition"
  >
    <template #activator="{ on }">
      <v-btn
        icon
        class="elevation-2"
        v-on="on"
      >
        <v-badge
          color="success"
          dot
          bordered
          offset-x="10"
          offset-y="10"
        >
          <User-Avatar
            :user="user"
            :detail="false"
          />
        </v-badge>
      </v-btn>
    </template>
    <v-list
      dense
      nav
    >
      <v-list-item @click="SendWhatsApp">
        <v-list-item-icon>
          <v-icon small>mdi-whatsapp</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Soporte</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <a
        id="sendWhatsApp"
        href="https://wa.me/51975606897"
        target="_blank"
      />
      <v-divider class="my-1" />
      <v-list-item @click="OpenMyAccountView()">
        <v-list-item-icon>
          <v-icon small>mdi-account-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Mi usuario</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-1" />
      <v-list-item @click="$store.dispatch('logout')">
        <v-list-item-icon>
          <v-icon small>mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import config from '../../configs'
import UserAvatar from '@/components/reports/userAvatar'
/*
|---------------------------------------------------------------------
| Toolbar User Component
|---------------------------------------------------------------------
|
| Quickmenu for user menu shortcuts on the toolbar
|
*/
export default {
  components: {
    UserAvatar
  },
  data() {
    return {
      menu: config.toolbar.user
    }
  },
  computed: {
    user: function () {
      return {
        name: $cookies.get('user').name
      }
    }
  },
  methods: {
    SendWhatsApp() {
      document.getElementById('sendWhatsApp').click()
    },
    OpenMyAccountView() {
      this.$router.push({ path: '/config/users/myAccount/' })
    } 
  }
}
</script>
